export default __webpack_public_path__ + "static/media/pc_background3.c09e6ddf.png";